<template>
    <div :style="[elementStyles, basicContentStyles]">
        <div :style="iconStyles"></div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'description', 'frame', 'infoStyles', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    backgroundImage: "linear-gradient(45deg, #cccccc 25%, transparent 25%, transparent 75%, #cccccc 75%, #cccccc), linear-gradient(45deg, #cccccc 25%, transparent 25%, transparent 75%, #cccccc 75%, #cccccc)",
                    backgroundSize: "4px 4px",
                    backgroundPosition: "0 0, 2px 2px",
                    backgroundRepeat: "unset",
                    opacity: opacity,
                }
            },
            iconStyles: function () {
                return {
                    backgroundImage: 'url("' + this.data.background_image + '")',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '100%'
                }
            },
            info: function () {
                var info = '';
                var name = this.data.name;

                if (this.description === '') {
                    info = name;
                } else {
                    info = '[' + name + '] ' + this.description;
                }

                return info;
            }
        }
    }
</script>
